export default function BoxIcon({ color = '#E1E5EB' }: { color?: string }) {
  return (
    <svg width="183" height="174" viewBox="0 0 183 174" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M199.325 68.8221C199.325 74.1771 196.449 79.036 191.888 81.5152L174.632 90.8369L159.956 98.6714L129.512 115.133C126.239 116.918 122.669 117.811 119 117.811C115.331 117.811 111.761 116.918 108.488 115.133L46.1124 81.5152C41.5508 79.036 38.6749 74.1771 38.6749 68.8221C38.6749 63.4671 41.5508 58.6077 46.1124 56.1285L65.6483 45.6169L81.2175 37.188L108.488 22.5115C115.033 18.9415 122.967 18.9415 129.512 22.5115L191.888 56.1285C196.449 58.6077 199.325 63.4671 199.325 68.8221Z"
        fill={color}
      />
      <path
        opacity="0.4"
        d="M98.175 126.834L40.1624 97.7783C35.6999 95.4975 30.5433 95.795 26.2791 98.3733C22.015 100.952 19.5359 105.514 19.5359 110.472V165.311C19.5359 174.831 24.7916 183.359 33.3199 187.623L91.3325 216.58C93.3158 217.572 95.4976 218.068 97.6793 218.068C100.258 218.068 102.836 217.374 105.117 215.886C109.381 213.308 111.86 208.746 111.86 203.788V148.949C111.959 139.627 106.703 131.098 98.175 126.834Z"
        fill={color}
      />
      <path
        opacity="0.4"
        d="M218.464 110.572V165.411C218.464 174.832 213.209 183.36 204.68 187.624L146.668 216.68C144.684 217.672 142.502 218.168 140.321 218.168C137.742 218.168 135.164 217.474 132.784 215.986C128.619 213.408 126.041 208.846 126.041 203.888V149.147C126.041 139.627 131.297 131.099 139.825 126.835L161.146 116.224L176.021 108.787L197.838 97.8785C202.3 95.5976 207.457 95.7959 211.721 98.4734C215.886 101.052 218.464 105.614 218.464 110.572Z"
        fill={color}
      />
      <path
        d="M174.632 90.8364L159.956 98.671L65.6483 45.6164L81.2176 37.1875L172.252 88.5558C173.244 89.1508 174.037 89.9439 174.632 90.8364Z"
        fill={color}
      />
      <path
        d="M176.021 108.785V131.296C176.021 135.362 172.649 138.734 168.583 138.734C164.518 138.734 161.146 135.362 161.146 131.296V116.223L176.021 108.785Z"
        fill={color}
      />
    </svg>
  );
}
